import React, { Component, PropTypes } from 'react';
import { connectReduxForm } from 'redux-form';
import { validateForgotPassword } from 'utils/validateNormalize';
import Spinner from 'react-spinner';
import 'react-spinner/react-spinner.css';
import './spinnerButton.scss';

@connectReduxForm({
  form: 'forgotPassword',
  fields: ['email', 'alert', 'accepted'],
  validate: validateForgotPassword
})
export default class ForgotPasswordForm extends Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired
  }

  render () {
    const { fields: {
              alert,
              email
            },
            handleSubmit,
            submitting } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <h2>Forgot password?</h2>
        {alert.error &&
        <div className="form-group">
          <div className="alert alert-danger" dangerouslySetInnerHTML={{__html: alert.error}}>
          </div>
        </div>
        }

        <div className="row">
          <div className="col-sm-8 col-md-6">
            <div className={'form-group ' +
                            (email.error && email.touched && 'has-error')}>
              <label htmlFor="txtEmail"
                     className="control-label">
                Enter email to request a password reset
              </label>
              <input id="txtEmail"
                     type="email"
                     className="form-control"
                     placeholder="jane@example.com"
                     spellCheck="false"
                     {...email} />
              {email.error && email.touched &&
               <div className="text-danger" dangerouslySetInnerHTML={{__html: email.error}}></div>
              }
            </div>
            <div className="form-group">
              <button type="submit"
                      className={'btn btn-primary spinnerButton ' +
                                 (submitting ? 'disabled' : '')}>
                <div className="buttonContent">
                  <div className="buttonText">
                    {submitting ?
                      'Sending password reset email' :
                      'Send password reset email'
                    }
                  </div>
                  {submitting &&
                  <div className="spinnerWrapper">
                    <Spinner />
                  </div>
                  }
                </div>
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/auth/forgotPasswordForm.jsx